import { sx } from '../lib/sx'

/** Transient confirmation banner, shown on either handset. */
export function Toast({ text }: { text: string }) {
  return (
    <div
      style={sx(
        'position:absolute;top:60px;left:12px;right:12px;z-index:9;padding:14px 16px;' +
          'border-radius:var(--radius-md);background:var(--bg-secondary);' +
          'border:1px solid var(--border-secondary);box-shadow:var(--shadow-modal);' +
          'display:flex;gap:12px;align-items:center;animation:gpop 250ms var(--ease-out)'
      )}
    >
      <span
        style={sx(
          'width:20px;height:20px;flex:none;background:var(--text-success);' +
            '-webkit-mask:url(/assets/icons/checkmark.svg) center/contain no-repeat;' +
            'mask:url(/assets/icons/checkmark.svg) center/contain no-repeat'
        )}
      />
      <span style={sx('font-size:var(--fs-sm);line-height:20px;font-weight:var(--fw-medium)')}>
        {text}
      </span>
    </div>
  )
}
